import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const EmailTemplatesPage = lazy(() => import('@/pages/emails/templates'));

export const Route = createFileRoute('/emails/templates')({
  component: function EmailTemplatesRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <EmailTemplatesPage />
      </Suspense>
    );
  },
});
